import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  size: 'full',
  path: 'workspace',
  children: {
    view: {
      size: 'full',
      path: 'view',
      children: {
        dataAccuracy: {
          size: 'full',
          path: 'data-accuracy',
        },
        costCenterBreakdown: {
          size: 'full',
          path: 'cost-center-breakdown/:id',
        },
        totalCostsDetail: {
          size: 'full',
          path: 'total-costs-detail/:period',
        },
        selectPayrollConcepts: {
          size: 'full',
          path: 'select-payroll-concepts',
        },
      },
    },
  },
} as const satisfies Location
